import axios from 'axios';
import sesionService from '@/services/SesionService';

export default {
	async getRoles() {
		const HEADER = await sesionService.getHeader();
		if (HEADER !== '') {
			try {
				let res = await axios.get('/role/all', HEADER);
				return res;
			} catch (error) {
				console.log(error);
			}
		}
	}
};
